<template>
    <div class="appWrapper">
    <div v-if="!showThankYouMessage">
        <h1 class="headlineText">GUEST</h1>
        <form @submit.prevent="formSubmit" id="guestForm">
            <div class="form-group heroForm">
                <label for="title">Title</label>
                <select class="customSelect" name="Title" v-model="Title" required>
                    <option default selected disabled value="">Select from list</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Ms.">Ms.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Dr.">Dr.</option>
                    <option value="Prof.">Prof.</option>
                    <option value="Adv.">Adv.</option>
                    <option value="Gen.">Gen.</option>
                    <option value="Rev.">Rev.</option>
                </select>
            </div>
            <div class="form-group heroForm">
                <label for="firstName">First Name</label>
                <input type="text" class="heroInputArea text" id="firstName" name="firstName" placeholder="" v-model="FirstName" required />
            </div>
            <div class="form-group heroForm">
                <label for="lastName">Last Name</label>
                <input type="text" class="heroInputArea text" id="lastName" name="lastName" placeholder="" v-model="LastName" required />
            </div>
            <div class="form-group heroForm">
                <label for="mobile">Mobile</label>
                <input type="text" class="heroInputArea text" id="mobile" name="mobile" placeholder="" v-model="MobilePhone" required />
                <span v-if="!isMobileValid" style="color: red;">Invalid mobile number. Please enter a valid number.</span>

            </div>
            <div class="form-group heroForm">
                <label for="email">E-mail</label>
                <input type="email" class="heroInputArea text" id="email" name="email" placeholder="" v-model="Email" required  />
            </div>
            <div class="checkOptionWrapper">
                <div class="checkOptionText">Dietary Requirements</div>
                <div class="CheckboxOptionWrapper">
                    <div v-for="option in dietaryOptions" :key="option.value" class="form-group checkboxHero checkbox-firstline">
                        <div>
                            <input type="checkbox" :id="option.value" :value="option.value" v-model="selectedDietaryRequirements" />
                            <label :for="option.value">{{ option.label }}</label>
                        </div>
                    </div>
                </div>
                <div class="form-group heroForm" v-if="selectedDietaryRequirements.includes('Other')">

                    <input class="heroInputArea text" type="text" placeholder="Other"  v-model="AC_Dietary_If_Other__c" >
                    <span v-if=" selectedDietaryRequirements.includes('Other') && AC_Dietary_If_Other__c === ''" style="color: red;">Required field.</span>  

                  </div>
                <span v-if="selectedDietaryRequirements.length < 1 && dietaryRequirementsOnSubmit" style="color: red;">Please select atleast one option</span>
            </div>


            <section>
                <div class="form-group checkboxHero checkbox-firstline">
                    <div>
                        <input type="checkbox" id="marketing" name="" v-model="Has_Opted_Out_Of_Marketing_Material__c"/>
                        <label for="marketing">I'D LIKE TO RECEIVE MARKETING COMMUNICATION FROM NISSAN
                        </label>
                    </div>
                </div>
                <p class="mutedLabel">
                    I agree that I will be kept informed of the latest vehicles and other products and services that may be
                    of interest. Nissan Group may occasionally ask for my assistance with market research to help improve
                    their services to customers. Further details are available on <a href="https://www.nissan.co.za/privacy-statement.html">Privacy Policy</a>
                </p>
                <label v-if="isError" class="errorLabel isError">{{ errorMessage }}</label>
            </section>
            <button type="submit" class="ctaPrimary font-icon formSubmitBtn">SUBMIT</button>
        </form>
    </div>
    <ThankYou v-if="showThankYouMessage" />
</div>
</template>

<script>
import axios from 'axios';
import { updateSalesforceLead, base_be_url } from '@/utils/api';
import { validateMobile, dietaryOptions } from '@/utils/constants';
import ThankYou from '@/components/ThankYou.vue';
import adobeAnalytics from "@/plugin/analytics";

export default {
    components: {
        ThankYou,
    },
    data() {
        return {
            isFocused: false,
            Title: "",
            Email: "",
            LastName: "",
            FirstName: "", 
            MobilePhone: "",
            Dietary_Requirements__c: "",
            Has_Opted_Out_Of_Marketing_Material__c: true,
            AC_Dietary_If_Other__c: "",
            isMobileValid: true,
            isError:false,
            errorMessage: "",
            showThankYouMessage: false,
            dietaryOptions: dietaryOptions,
            selectedDietaryRequirements: [],
            dietaryRequirementsOnSubmit: false,
        };
    },
    methods: {
        fetchData() {
            try {
                const salesForceId = this.$route.query.sales_force_id;
                const apiUrl = `${base_be_url}?sales_force_id=${salesForceId}`;

                axios.get(apiUrl)
                    .then(response => {
                        // Handle the successful response
                        const res = response.data;
                        if (res.success && res.response.totalSize > 0 ) {
                            this.Title = res.response.records[0].Title;
                            this.FirstName = res.response.records[0].FirstName;
                            this.LastName = res.response.records[0].LastName;
                            this.Email = res.response.records[0].Email;
                            this.MobilePhone = res.response.records[0].MobilePhone;
                            
                            this.Has_Opted_Out_Of_Marketing_Material__c = res.response.records[0].Has_Opted_Out_Of_Marketing_Material__c;
                            if(res.response.records[0].Dietary_Requirements__c)
                            this.selectedDietaryRequirements = res.response.records[0].Dietary_Requirements__c.split(', ')

                            // Adobe Analytics Starts
                        }
                        else{
                            this.$router.push(`/`);
                        }
                    })
            } catch (error) {
                this.$router.push(`/`);

                console.log('ower not found');
            }
        },
        async formSubmit() {
            this.errorMessage = "";
            this.isError = false;
            this.isMobileValid = validateMobile(this.MobilePhone);

            if (!this.isMobileValid) {
                console.log('Invalid mobile number');
                return;
            }

            this.dietaryRequirementsOnSubmit = true;
            if(this.selectedDietaryRequirements.length < 1) {
              return false;
            } 

            if(this.selectedDietaryRequirements.includes('Other') && this.AC_Dietary_If_Other__c === "") {
            return false;
          }

            const postData = {
                Title: this.Title,
                Email: this.Email,
                Lastname: this.LastName,
                Firstname: this.FirstName,
                MobilePhone: this.MobilePhone,
                Dietary_Requirements__c: this.selectedDietaryRequirements.join(', '),
                AC_Dietary_If_Other__c : this.AC_Dietary_If_Other__c,
                Has_Opted_Out_Of_Marketing_Material__c: this.Has_Opted_Out_Of_Marketing_Material__c,
                NSA_StatusReason__c:"Booked",
                'owner': false,
            };

            try {
                const salesForceId = this.$route.query.sales_force_id;
                const response = await updateSalesforceLead(`${base_be_url}?lead_id=${salesForceId}`, postData);
                // Handle the successful response
                
                if(response.status == 200) {

                  this.showThankYouMessage = true;
                  // Adobe Analytics Starts
                  let event_happened = "Form Complete | Guest";
                  let events = 'event51';
                  let event_126 = "";
                  let eVar14 = event_happened;
                  // let eVar14 = event_happened + "|" + url

                  adobeAnalytics("R","","","","","EN",event_happened,"","","",event_126,events,"","",eVar14);
                  // Adobe Analytics Ends

                } else {
                  this.errorMessage = response.data.message;
                  this.isError = true;
                  console.error('Error submitting form:', response.data.message);
                }
            } catch (error) {
                this.errorMessage = error;
                this.isError = true;
            }
        },
        onFocus(event) {
          // console.log("Element focused:", event.target.tagName);
          if(this.isFocused === false) {
            if (!event.target.hasAttribute("data-focused")) {
              event.target.setAttribute("data-focused", true);
            }
            this.isFocused = true;
            // Adobe Analytics Starts
            let event_happened = "Form Start";
            let event_126 = "";
            let events = 'event50';
            let eVar14 = event_happened;
            // let eVar14 = event_happened + "|" + url

            adobeAnalytics("R","","","","","EN",event_happened,"","","",event_126,events,"","",eVar14);
            // Adobe Analytics Ends
          }
        }
    },
    mounted() {
        // Fetch data when the component is mounted
        this.fetchData();
        const form = document.getElementById("guestForm");
        if (!form) return; // Ensure the form element exists
        // Get all input, select, checkbox, and radio elements within the form
        const elements = form.querySelectorAll("input, select, checkbox, radio");
        // Add focus event listener to each element
        elements.forEach(element => {
          element.addEventListener("focus", this.onFocus);
        });
    },

};
</script>

<style></style>